module.exports = __webpack_public_path__ + "img/health-monitoring-bg--disabled.8875752b.png";